var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m-1.25-5.5a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h2.5c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75H11V9.75a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h.75v2zM10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};
export default SvgInfoCircle;